<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        class="fixed inset-0 z-50 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <!-- Overlay -->
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            @click="handleClose"
          />

          <!-- Modal -->
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <!-- Header -->
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="flex items-start">
                <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900 mb-4">
                    Aide et support
                  </h3>
                  
                  <div class="mt-2 max-h-96 overflow-y-auto">
                    <div class="text-sm text-gray-500 space-y-4">
                      <div>
                        <strong class="text-gray-700">Questions fréquentes</strong>
                      </div>
                      
                      <div>
                        <p class="font-medium text-gray-700">Comment créer un compte ?</p>
                        <p>Cliquez sur "Créer un compte" et remplissez le formulaire avec vos informations. Seuls le nom et l'email sont obligatoires.</p>
                      </div>
                      
                      <div>
                        <p class="font-medium text-gray-700">J'ai oublié mon mot de passe</p>
                        <p>Cliquez sur "Mot de passe oublié ?" sur la page de connexion et suivez les instructions envoyées par email.</p>
                      </div>
                      
                      <div>
                        <p class="font-medium text-gray-700">Qui peut utiliser Anamnesis ?</p>
                        <p>La plateforme est destinée aux professionnels du patrimoine : archéologues, restaurateurs, chercheurs, conservateurs, etc.</p>
                      </div>
                      
                      <div>
                        <p class="font-medium text-gray-700">Mes données sont-elles sécurisées ?</p>
                        <p>Oui, nous utilisons des protocoles de sécurité standards et ne partageons jamais vos données avec des tiers.</p>
                      </div>
                      
                      <div class="border-t pt-4">
                        <strong class="text-gray-700">Besoin d'aide supplémentaire ?</strong>
                        <p class="mt-2">
                          Contactez notre équipe support :<br>
                          <span class="font-medium">Email :</span> support@anamnesis-platform.com<br>
                          <span class="font-medium">Réponse :</span> Sous 24h en jours ouvrés
                        </p>
                      </div>
                      
                      <div class="bg-blue-50 p-3 rounded-md">
                        <p class="text-blue-800 text-xs">
                          <strong>Astuce :</strong> Gardez vos identifiants en sécurité et utilisez un mot de passe fort avec au moins 8 caractères, incluant majuscules, minuscules, chiffres et caractères spéciaux.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Footer -->
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
                @click="handleClose"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface HelpModalProps {
  modelValue: boolean;
}

export interface HelpModalEmits {
  (e: 'update:modelValue', value: boolean): void;
}

const props = defineProps<HelpModalProps>();
const emit = defineEmits<HelpModalEmits>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const handleClose = (): void => {
  show.value = false;
};
</script> 